if (!customElements.get('spi-image-text')) {
  class SpiImageText extends HTMLElement {
    connectedCallback() {
      this._initVideos();
      this._initSlider();
    }

    _initVideos() {
      this.querySelectorAll('video').forEach((v) => {
        v.muted = true;
        v.play().catch(() => {});
      });
    }

    _initSlider() {
      this.slides = Array.from(this.querySelectorAll('.spi-it-slide'));
      this.dots = Array.from(this.querySelectorAll('.spi-it-dot'));

      if (this.slides.length <= 1) return;

      this.current = 0;
      this._show(0);

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          clearInterval(this._timer);
          this._show(i);
          this._startTimer();
        });
      });

      this._startTimer();
    }

    _show(index) {
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      this.current = index;
    }

    _startTimer() {
      const speed = parseInt(this.dataset.speed || '4000', 10);
      this._timer = setInterval(() => {
        const next = (this.current + 1) % this.slides.length;
        this._show(next);
      }, speed);
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }
  }

  customElements.define('spi-image-text', SpiImageText);
}
